import { render, staticRenderFns } from "./QuizActivityExcludeCatalogs.vue?vue&type=template&id=67821a10&"
import script from "./QuizActivityExcludeCatalogs.vue?vue&type=script&lang=js&"
export * from "./QuizActivityExcludeCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports